import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import '../Reports.scss';
import { CsvToIntArray } from '../../../helpers/strings';

export class UserListFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            isUserActive: '',
            userGroupIds: ''
        }

        this.state = {
            emptyForm: initialFormSelections,
            isUserActive: initialFormSelections.isUserActive,
            userActiveOptions: [ { id: 'true', name: 'Active' }, { id: 'false', name: 'Inactive' }],
            userGroupIds: initialFormSelections.userGroupIds
        }
    }

    componentDidMount = async () => {
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
        this.setDefaults();
    }

    setDefaults = () => {
        let newState = {...this.state};

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,
                isUserActive: appState.isUserActive ? appState.isUserActive : newState.isUserActive,
                userGroupIds: appState.userGroupIds ? appState.userGroupIds : newState.userGroupIds
            }
        }

        this.setState({
            ...this.state,
            ...newState
        });
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        if (!this.state.userGroupIds || this.state.userGroupIds <= 0 || !this.state.isUserActive || this.state.isUserActive <= 0) {
            return false;
        }

        return true;
    }

    mapToForm = () => {
        Notification("error", "Error", `Map To Form Not Implemented for ${this.props.report.name} yet`);
    }

    mapToApiRequest = () => {
        const request = {
            reportId: this.props.report.id,
            isUserActive: this.state.isUserActive,
            userGroupIds: CsvToIntArray(this.state.userGroupIds)
        };

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onFieldChange = (name, value) => {
        this.setState({ ...this.state, [name]: value });
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    render() {
        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <MultiSelectBox name="userGroupIds"
                            label="User Group" idField="id" valueField="name"
                            options={this.props.filters.userGroups}
                            selectedValues={this.state.userGroupIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={true}
                            errorMessage="User Group is required"
                            isMulti={true} /> 
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <MultiSelectBox name="isUserActive"
                            label="User Status" idField="id" valueField="name"
                            options={this.state.userActiveOptions}
                            selectedValues={this.state.isUserActive.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={true}
                            errorMessage="User Status is required"
                            isMulti={false} />            
                    </div>
                </div>
             
            </form>
        );
    }
}

UserListFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired,
    urlParams: PropTypes.object.isRequired,
    savedFilterValues: PropTypes.object.isRequired
};

export default UserListFilters;
